/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_FurnitureInputs */

const en_listing_category_furniture = /** @type {(inputs: Listing_Category_FurnitureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Furniture`)
};

const es_listing_category_furniture = /** @type {(inputs: Listing_Category_FurnitureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muebles`)
};

const fr_listing_category_furniture = /** @type {(inputs: Listing_Category_FurnitureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meubles`)
};

const de_listing_category_furniture = /** @type {(inputs: Listing_Category_FurnitureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möbel`)
};

const ja_listing_category_furniture = /** @type {(inputs: Listing_Category_FurnitureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`家具`)
};

const zh_listing_category_furniture = /** @type {(inputs: Listing_Category_FurnitureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`家具`)
};

const ar_listing_category_furniture = /** @type {(inputs: Listing_Category_FurnitureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أثاث`)
};

const id_listing_category_furniture = /** @type {(inputs: Listing_Category_FurnitureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Furnitur`)
};

const it_listing_category_furniture = /** @type {(inputs: Listing_Category_FurnitureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arredamento`)
};

const ru_listing_category_furniture = /** @type {(inputs: Listing_Category_FurnitureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мебель`)
};

const pt_listing_category_furniture = /** @type {(inputs: Listing_Category_FurnitureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Móveis`)
};

const ko_listing_category_furniture = /** @type {(inputs: Listing_Category_FurnitureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가구`)
};

/**
* | output |
* | --- |
* | "Furniture" |
*
* @param {Listing_Category_FurnitureInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_furniture = /** @type {((inputs?: Listing_Category_FurnitureInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_FurnitureInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_furniture(inputs)
	if (locale === "es") return es_listing_category_furniture(inputs)
	if (locale === "fr") return fr_listing_category_furniture(inputs)
	if (locale === "de") return de_listing_category_furniture(inputs)
	if (locale === "ja") return ja_listing_category_furniture(inputs)
	if (locale === "zh") return zh_listing_category_furniture(inputs)
	if (locale === "ar") return ar_listing_category_furniture(inputs)
	if (locale === "id") return id_listing_category_furniture(inputs)
	if (locale === "it") return it_listing_category_furniture(inputs)
	if (locale === "ru") return ru_listing_category_furniture(inputs)
	if (locale === "pt") return pt_listing_category_furniture(inputs)
	return ko_listing_category_furniture(inputs)
});